// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── New Organisations ───────────────────────────────────────────────────── */

.ecr-new-orgs {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Toolbar */
.ecr-new-orgs__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
}

.ecr-new-orgs__count {
  margin-left: auto;
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
}

/* Quick Actions section */
.ecr-new-orgs__quick-actions {
  background: linear-gradient(135deg, #f0fdf4 0%, #e6f9f1 100%);
  border: 1px solid #86BC25;
  border-radius: 10px;
  padding: 18px 20px;
}

.ecr-new-orgs__quick-actions-header {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 14px;
}

.ecr-new-orgs__quick-actions-title {
  font-size: 13px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -0.01em;
}

.ecr-new-orgs__quick-actions-desc {
  font-size: 12px;
  color: #6b7280;
}

.ecr-new-orgs__quick-actions-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.ecr-new-orgs__action-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  text-decoration: none;
  transition: all 0.15s ease;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.ecr-new-orgs__action-chip:hover {
  background: #86BC25;
  border-color: #86BC25;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(134, 188, 37, 0.2);
}

.ecr-new-orgs__action-chip-icon {
  font-size: 18px !important;
  flex-shrink: 0;
}

.ecr-new-orgs__action-chip-text {
  font-weight: 600;
}

.ecr-new-orgs__action-chip-external {
  font-size: 14px !important;
  margin-left: auto;
  opacity: 0.6;
  flex-shrink: 0;
}

.ecr-new-orgs__action-chip:hover .ecr-new-orgs__action-chip-external {
  opacity: 1;
}

/* Table shell */
.ecr-new-orgs__table {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-top: 3px solid #86BC25;
  border-radius: 10px;
  overflow: hidden;
}

/* Header row */
.ecr-new-orgs__header {
  display: flex;
  align-items: center;
  background: #F8FAFC;
  padding: 11px 20px;
  gap: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #111827;
  border-bottom: 1px solid #DCE3EA;
}

/* Data row */
.ecr-new-orgs__row {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  gap: 12px;
  border-bottom: 1px solid #E9EEF3;
  transition: background 0.12s;
}

.ecr-new-orgs__row:last-child {
  border-bottom: none;
}

.ecr-new-orgs__row:hover {
  background: #F8FAFC;
}

/* Columns */
.ecr-new-orgs__col { display: flex; flex-direction: column; gap: 2px; }
.ecr-new-orgs__col--name   { flex: 3 1; min-width: 0; flex-direction: row; align-items: center; gap: 8px; }
.ecr-new-orgs__col--ref    { flex: 1.2 1; min-width: 100px; }
.ecr-new-orgs__col--id     { flex: 2 1; min-width: 0; }
.ecr-new-orgs__col--status { flex: 0.8 1; min-width: 90px; align-items: flex-start; }
.ecr-new-orgs__col--action { flex: 0 0 160px; align-items: flex-end; justify-content: center; flex-direction: row; }

/* Org name */
.ecr-new-orgs__name {
  font-size: 13px;
  font-weight: 700;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* GitHub link icon */
.ecr-new-orgs__gh-link {
  color: #9ca3af;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: color 0.15s;
}

.ecr-new-orgs__gh-link:hover {
  color: #86BC25;
}

/* Label above value */
.ecr-new-orgs__label-tiny {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #d1d5db;
}

/* Copy row */
.ecr-new-orgs__copy-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Code chip */
.ecr-new-orgs__code {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  color: #374151;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 2px 7px;
  border-radius: 5px;
}

.ecr-new-orgs__code--id {
  font-size: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  display: inline-block;
}

/* Empty / error state */
.ecr-new-orgs__empty {
  padding: 40px 24px;
  text-align: center;
  color: #9ca3af;
  font-size: 13px;
}

/* Skeleton rows */
.ecr-new-orgs__row--skeleton {
  pointer-events: none;
}

.ecr-new-orgs__skeleton-bar {
  height: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg, #f3f4f6 25%, #e9eaec 50%, #f3f4f6 75%);
  background-size: 400px 100%;
  animation: ecr-shimmer 1.3s infinite linear;
}

@keyframes ecr-shimmer {
  0%   { background-position: -400px 0; }
  100% { background-position:  400px 0; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/EcrOpsNewOrgs.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACtE,6BAA6B,SAAO,EAAE,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACxG,6BAA6B,WAAS,EAAE,gBAAgB,EAAE;AAC1D,6BAA6B,SAAO,EAAE,YAAY,EAAE;AACpD,6BAA6B,WAAS,EAAE,eAAe,EAAE,uBAAuB,EAAE;AAClF,6BAA6B,eAAe,EAAE,qBAAqB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;;AAEnH,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,4EAA4E;EAC5E,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC","sourcesContent":["/* ── New Organisations ───────────────────────────────────────────────────── */\n\n.ecr-new-orgs {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Toolbar */\n.ecr-new-orgs__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 14px 16px;\n}\n\n.ecr-new-orgs__count {\n  margin-left: auto;\n  font-size: 12px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n/* Quick Actions section */\n.ecr-new-orgs__quick-actions {\n  background: linear-gradient(135deg, #f0fdf4 0%, #e6f9f1 100%);\n  border: 1px solid #86BC25;\n  border-radius: 10px;\n  padding: 18px 20px;\n}\n\n.ecr-new-orgs__quick-actions-header {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 14px;\n}\n\n.ecr-new-orgs__quick-actions-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #111827;\n  letter-spacing: -0.01em;\n}\n\n.ecr-new-orgs__quick-actions-desc {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.ecr-new-orgs__quick-actions-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.ecr-new-orgs__action-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fff;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  text-decoration: none;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.ecr-new-orgs__action-chip:hover {\n  background: #86BC25;\n  border-color: #86BC25;\n  color: #fff;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(134, 188, 37, 0.2);\n}\n\n.ecr-new-orgs__action-chip-icon {\n  font-size: 18px !important;\n  flex-shrink: 0;\n}\n\n.ecr-new-orgs__action-chip-text {\n  font-weight: 600;\n}\n\n.ecr-new-orgs__action-chip-external {\n  font-size: 14px !important;\n  margin-left: auto;\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n\n.ecr-new-orgs__action-chip:hover .ecr-new-orgs__action-chip-external {\n  opacity: 1;\n}\n\n/* Table shell */\n.ecr-new-orgs__table {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-top: 3px solid #86BC25;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n/* Header row */\n.ecr-new-orgs__header {\n  display: flex;\n  align-items: center;\n  background: #F8FAFC;\n  padding: 11px 20px;\n  gap: 12px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: #111827;\n  border-bottom: 1px solid #DCE3EA;\n}\n\n/* Data row */\n.ecr-new-orgs__row {\n  display: flex;\n  align-items: center;\n  padding: 14px 20px;\n  gap: 12px;\n  border-bottom: 1px solid #E9EEF3;\n  transition: background 0.12s;\n}\n\n.ecr-new-orgs__row:last-child {\n  border-bottom: none;\n}\n\n.ecr-new-orgs__row:hover {\n  background: #F8FAFC;\n}\n\n/* Columns */\n.ecr-new-orgs__col { display: flex; flex-direction: column; gap: 2px; }\n.ecr-new-orgs__col--name   { flex: 3; min-width: 0; flex-direction: row; align-items: center; gap: 8px; }\n.ecr-new-orgs__col--ref    { flex: 1.2; min-width: 100px; }\n.ecr-new-orgs__col--id     { flex: 2; min-width: 0; }\n.ecr-new-orgs__col--status { flex: 0.8; min-width: 90px; align-items: flex-start; }\n.ecr-new-orgs__col--action { flex: 0 0 160px; align-items: flex-end; justify-content: center; flex-direction: row; }\n\n/* Org name */\n.ecr-new-orgs__name {\n  font-size: 13px;\n  font-weight: 700;\n  color: #111827;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* GitHub link icon */\n.ecr-new-orgs__gh-link {\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  transition: color 0.15s;\n}\n\n.ecr-new-orgs__gh-link:hover {\n  color: #86BC25;\n}\n\n/* Label above value */\n.ecr-new-orgs__label-tiny {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #d1d5db;\n}\n\n/* Copy row */\n.ecr-new-orgs__copy-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Code chip */\n.ecr-new-orgs__code {\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 12px;\n  color: #374151;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  padding: 2px 7px;\n  border-radius: 5px;\n}\n\n.ecr-new-orgs__code--id {\n  font-size: 11px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 200px;\n  display: inline-block;\n}\n\n/* Empty / error state */\n.ecr-new-orgs__empty {\n  padding: 40px 24px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n/* Skeleton rows */\n.ecr-new-orgs__row--skeleton {\n  pointer-events: none;\n}\n\n.ecr-new-orgs__skeleton-bar {\n  height: 14px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #f3f4f6 25%, #e9eaec 50%, #f3f4f6 75%);\n  background-size: 400px 100%;\n  animation: ecr-shimmer 1.3s infinite linear;\n}\n\n@keyframes ecr-shimmer {\n  0%   { background-position: -400px 0; }\n  100% { background-position:  400px 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
